module.exports = __webpack_public_path__ + "static/media/pfbg_576@2x.b48e77bc.jpg";